module.exports = __webpack_public_path__ + "static/media/26130014-IFSzwSgs.11ce11bd.JPG";